import { isTasklistComplete } from "@pathwright/blocks-core/src/blocks/tasklist/block-type"
import {
    BLOCK_INPUT_STATES,
    EDITOR_MODE,
    useBlockCompletion
} from "@pathwright/blocks-engine"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import React from "react"
import QuestionHeader from "../Question/QuestionHeader"
import Tasklist from "./Tasklist"
import { CompletedTasks, ListContainer } from "./ui"
import { getTasklistProgress } from "./utils"

const TasklistView = (props) => {
  const { data } = props
  const { t } = useTranslate()

  const { setUseAutocomplete, setBlockFunctions, getBlurProps } =
    useBlockCompletion()

  React.useEffect(() => {
    setUseAutocomplete(true)
    setBlockFunctions({
      validateInput,
      getBlockIsCompleted
    })
  }, [])

  const validateInput = (data) => {
    if (!data.completedTasks || !data.completedTasks.length)
      return BLOCK_INPUT_STATES.NONE

    return isTasklistComplete(data)
      ? BLOCK_INPUT_STATES.VALID
      : BLOCK_INPUT_STATES.INVALID
  }

  const getBlockIsCompleted = (data) => isTasklistComplete(data)

  const tasklistProgress = getTasklistProgress(data.tasks, data.completedTasks)

  // Ensure no of completed tasks never exceeds total no of tasks
  // This can happen if a task is deleted after it is completed
  const completedCount = Math.min(
    tasklistProgress.complete,
    tasklistProgress.total
  )

  let completeText = `${t("blocks.tasklist.completed")}: ${completedCount}/${
    tasklistProgress.total
  }`

  return (
    <Content.Container
      style={{ maxHeight: "100%" }} // prevent preview from looking wonky
    >
      <ListContainer {...getBlurProps()}>
        <QuestionHeader {...props} data={{ ...data, question: data.title }} />
        <CompletedTasks mode={EDITOR_MODE.VIEW}>{completeText}</CompletedTasks>
        <Tasklist {...props} mode={EDITOR_MODE.VIEW} />
      </ListContainer>
    </Content.Container>
  )
}

export default TasklistView
